import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Form from "./Form";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { Grid } from "@material-ui/core";
import { updateFile } from "../../actions/fileActions";

const SetExpirationDateForFileForm = (props) => {
  const [expirationDate, setExpirationDate] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onFormSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsFetching(true);
      await updateFile(props.fileId, { expirationDate });
      setSuccessMessage("Vervaldatum instellen is voltooid.");
      props.onSuccess();
    } catch (error) {
      setErrorMessage("Vervaldatum instellen is mislukt.");
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Fragment>
      <Form
        onSubmit={onFormSubmit}
        submitText="Instellen"
        isFetching={isFetching}
        successMessage={successMessage}
        errorMessage={errorMessage}
      >
        <Grid item xs={12} sm={12}>
          <KeyboardDateTimePicker
            clearable
            mask="__-__-____ __:__"
            id="expirationDate"
            name="expirationDate"
            label="Vervaldatum *"
            value={expirationDate}
            format={"L LT"}
            onChange={(m) => setExpirationDate(m)}
            fullWidth
            ampm={false}
          />
        </Grid>
      </Form>
    </Fragment>
  );
};

SetExpirationDateForFileForm.propTypes = {
  fileId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
};

export default SetExpirationDateForFileForm;



// WEBPACK FOOTER //
// ./src/components/forms/SetExpirationDateForFileForm.js